import { useEffect, useState } from 'react';
import { useSelector, Provider } from 'react-redux';
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools"
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
// routing
import "./views/custom.css";
import Routes from 'routes';
// defaultTheme
import themes from 'themes';
// project imports
import NavigationScroll from 'layout/NavigationScroll';
import { ToastContainer, Flip } from 'react-toastify';
import { store, persistor } from "./store/index.js";
import { PersistGate } from 'redux-persist/integration/react'

const queryClient = new QueryClient()
const App = () => {
  const customization = useSelector((state) => state.customization);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

useEffect(() => {
  const handleOnline = () => setIsOnline(true);
  const handleOffline = () => setIsOnline(false);

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  // ============ TEAM PAGE PLUGIN SCRIPT ============
  if (!window.__teamPageLoaded) {
    window.__teamPageLoaded = true;

    window.TEAM_PAGE_API = window.TEAM_PAGE_API || {};
    window.TEAM_PAGE_LoadStart = new Date();

    const script = document.createElement("script");
    script.src =
      "https://qaapi.teampage.in/api/v1/plugin/page/11e184b45f75ca59ccd77e6197d902fdbae1dfc60a3a66cd5f61ff4e972f4738c7861a7be1c374c3208851da85a5a9d849db37985b96a93ba6150a0c750de05e?key=898196159";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    document.body.appendChild(script);
  }
  // ================================================

  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
}, []);


  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <PersistGate persistor={persistor} >
            <ThemeProvider theme={themes(customization)}>
              <CssBaseline />
              {isOnline ? (
                <NavigationScroll>
                  <Routes />
                </NavigationScroll>
              ) : (
                <div style={{ textAlign: 'center', paddingTop: '50px', fontSize: "x-large" }}>
                  <img src='/no-internet.svg' alt='no-internet.svg' />
                </div>
              )}
            </ThemeProvider>
          </PersistGate>
        </StyledEngineProvider>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      <ToastContainer transition={Flip} position="top-right" autoClose={2000} hideProgressBar={false} closeOnClick={false} pauseOnHover={false} draggable={false} />
    </QueryClientProvider>
  );
};
export default App;